<div class="page-header">
  <div class="title-section">
    <h2 class="page-title">Gestion des sous-traitants</h2>
    <p class="page-subtitle">Liste de tous vos sous-traitants</p>
  </div>
  <a routerLink="/sous-traitants/new" class="btn btn-primary btn-with-icon">
    <mat-icon aria-hidden="true">add</mat-icon>
    Nouveau sous-traitant
  </a>
</div>

<div class="card shadow-sm mb-4">
  <div class="search-bar">
    <div class="search-bar-content">
      <div class="search-input-wrapper">
        <mat-icon class="search-icon" aria-hidden="true">search</mat-icon>
        <input
          type="text"
          [(ngModel)]="searchQuery"
          (ngModelChange)="onSearchChange($event)"
          placeholder="Rechercher un sous-traitant..."
          class="search-input"
        >
      </div>
      <div class="archived-toggle">
        <label class="checkbox-container">
          <input type="checkbox" [checked]="showArchived()" (change)="onToggleArchived()">
          <span class="checkmark"></span>
          Afficher les archivés
        </label>
      </div>
    </div>
  </div>

  <div class="table-responsive">
    <table class="modern-table" matSort (matSortChange)="onSortChange($event)" [matSortActive]="sortField">
      <thead>
      <tr>
        <th mat-sort-header="codeComptable">Code Comptable</th>
        <th mat-sort-header="denomination">Dénomination</th>
        <th mat-sort-header="siret">SIRET</th>
        <th mat-sort-header="qualification">Qualification</th>
        <th>Adresse</th>
        <th mat-sort-header="ville">Ville</th>
        <th mat-sort-header="codePostal">Code Postal</th>
      </tr>
      </thead>
      <tbody>
        @for (st of sousTraitants(); track st.id) {
          <tr (click)="onEdit(st)" class="clickable-row" [class.archived-row]="st.archived">
            <td>{{ st.codeComptable }}</td>
            <td>
              {{ st.denomination }}
              @if (st.archived) {
                <span class="badge-archived">Archivé</span>
              }
            </td>
            <td>{{ st.siret }}</td>
            <td>{{ st.qualification }}</td>
            <td>{{ st.adresse }}</td>
            <td>{{ st.ville }}</td>
            <td>{{ st.codePostal }}</td>
          </tr>
        } @empty {
          <tr class="empty-row">
            <td colspan="7">
              <div class="empty-state">
                <mat-icon class="empty-icon" aria-hidden="true">inbox</mat-icon>
                <p>Aucun sous-traitant trouvé</p>
              </div>
            </td>
          </tr>
        }
      </tbody>
    </table>
  </div>

  <mat-paginator [length]="totalElements()"
                 [pageSize]="size()"
                 [pageSizeOptions]="[5, 10, 25, 100]"
                 (page)="onPageChange($event)"
                 aria-label="Sélectionner la page">
  </mat-paginator>
</div>
